<template>
  <canvas ref="canvas" class="starfield" aria-hidden="true"></canvas>
</template>

<script>
export default {
  name: 'StarField',
  mounted() {
    const canvas = this.$refs.canvas;
    const ctx = canvas.getContext('2d');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let stars = [];
    let w = 0;
    let h = 0;

    const resize = () => {
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      canvas.style.width = `${w}px`;
      canvas.style.height = `${h}px`;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const count = Math.round((w * h) / 5200);
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * w,
        y: Math.random() * h * 3,
        r: Math.random() * 1.1 + 0.2,
        depth: Math.random() * 0.5 + 0.1,
        phase: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.8 + 0.2,
      }));
    };

    const draw = (t) => {
      ctx.clearRect(0, 0, w, h);
      const scroll = window.scrollY;
      for (const s of stars) {
        const y = (((s.y - scroll * s.depth) % (h * 3)) + h * 3) % (h * 3);
        if (y > h) continue;
        const twinkle = reduced ? 0.7 : 0.45 + 0.55 * Math.abs(Math.sin(t / 1000 * s.speed + s.phase));
        ctx.globalAlpha = twinkle * (0.35 + s.depth);
        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        ctx.arc(s.x, y, s.r, 0, Math.PI * 2);
        ctx.fill();
      }
      this.frame = requestAnimationFrame(draw);
    };

    resize();
    this.onResize = resize;
    window.addEventListener('resize', resize);
    this.frame = requestAnimationFrame(draw);
  },
  beforeUnmount() {
    cancelAnimationFrame(this.frame);
    window.removeEventListener('resize', this.onResize);
  },
};
</script>

<style scoped>
.starfield {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
}
</style>
